import { EDIT_TEAM, EDIT_TEAM_FAIL, EDIT_TEAM_SUCCESS } from './actionTypes';

const initialState = {
    userToEdit: {},
    editedUser: {},
    error: null,
    loading: false,
    loaded: false
};

export function editTeamReducer(state = initialState, action) {
    switch (action.type) {
        case EDIT_TEAM:
            return {
                ...initialState,
                userToEdit: action.payload,
                loading: true
            };
        case EDIT_TEAM_SUCCESS:
            return {
                ...state,
                editedUser: action.payload,
                loaded: true,
                loading: false
            };
        case EDIT_TEAM_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default:
            return state;
    }
}
